import { useState } from "react";

interface PostDescriptionProps {
    username: string;
    description: string;
    onDataChange: (key: string, value: string) => void;
}

export default function PostDescription({ username, description, onDataChange }: PostDescriptionProps) {
    const [isEditing, setIsEditing] = useState(false);

    const formatDescription = (text: string) => {
        return text.split(" ").map((word, index) => {
            if (word.startsWith("@") || word.startsWith("#")) {
                return <span key={index} className="text-blue-500">{word} </span>;
            }
            return word + " ";
        });
    };

    return (
        <div className="px-3 py-2">
            {isEditing ? (
                <textarea
                    value={description}
                    onChange={(e) => onDataChange("description", e.target.value)}
                    onBlur={() => setIsEditing(false)}
                    autoFocus
                    className="w-full p-2 border rounded outline-none min-h-32"
                />
            ) : (
                <p onClick={() => setIsEditing(true)} className="cursor-pointer">
                    <span className="font-semibold">{username}</span>{" "}
                    {formatDescription(description)}
                </p>
            )}
        </div>
    );
}